import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b1aa4cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container card-primary card-outline" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title my-1 p-1" }, "Usuarios", -1))
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Nuevo ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "card-body p-0" }
const _hoisted_10 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-12 text-right" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "example1_filter",
      class: "dataTables_filter"
    })
  ])
], -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "form-row align-items-center form-inline justify-content-around" }
const _hoisted_15 = { class: "form-group col-md-7 my-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1" }, "Buscar:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "form-group col-md-auto my-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1" }, "Estado:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, " SELECCIONA UN ESTADO ", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col col-sm-1 my-1" }
const _hoisted_24 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_29 = { class: "col-sm-12" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_35 = { role: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "sorting sorting_asc",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-sort": "ascending",
  "aria-label": "Rendering engine: activate to sort column descending"
}, " Nombre ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "sorting",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-label": "Browser: activate to sort column ascending"
}, " Correo electronico ", -1))
const _hoisted_38 = {
  key: 0,
  class: "sorting",
  tabindex: "0",
  "aria-controls": "example1",
  rowspan: "1",
  colspan: "1",
  "aria-label": "Platform(s): activate to sort column ascending"
}
const _hoisted_39 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_40 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_41 = {
  key: 0,
  class: "text-center"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "100%"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-sm-6" }
const _hoisted_51 = { class: "form-row align-items-center" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto my-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "ml-2" }, "Registros por página")
], -1))
const _hoisted_53 = { class: "col-auto my-1" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "col-sm-6" }
const _hoisted_56 = { class: "ml-2" }

export function render(_ctx, _cache) {
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isValidPermission('SEGURIDAD.CREAR_USUARIO'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.goToCreateUser && _ctx.goToCreateUser(...args)))
              }, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.filterStatusApp && _ctx.filterStatusApp(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.criteria) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.criteria]
                    ]),
                    (_ctx.criteria.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light m-1",
                          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.cleanCliteria && _ctx.cleanCliteria(...args)))
                        }, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control mr-sm-2",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.optionFilter) = $event))
                    }, [
                      _hoisted_21,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsStatusFilter, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: option.value
                        }, _toDisplayString(option.name), 9, _hoisted_22))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.optionFilter]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", _hoisted_24, [
                      (!_ctx.btnLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_27))
                        : _createCommentVNode("", true),
                      (_ctx.btnLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                  : _createCommentVNode("", true),
                _createElementVNode("table", _hoisted_34, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      (_ctx.isValidPermission('SEGURIDAD.EDITAR_USUARIO') || _ctx.isValidPermission('SEGURIDAD.ELIMINAR_USUARIO'))
                        ? (_openBlock(), _createElementBlock("th", _hoisted_38))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.users && _ctx.users.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "odd",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_40, _toDisplayString(user.name), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            (_ctx.isValidPermission('SEGURIDAD.EDITAR_USUARIO') || _ctx.isValidPermission('SEGURIDAD.ELIMINAR_USUARIO'))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                  (_ctx.isValidPermission('SEGURIDAD.EDITAR_USUARIO'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-outline-primary mr-lg-2 mr-sm-0 mr-md-0 mb-lg-0 mb-2 mb-sm-2 mb-md-2 my-auto",
                                        onClick: $event => (_ctx.editUser(user))
                                      }, _hoisted_44, 8, _hoisted_42))
                                    : _createCommentVNode("", true),
                                  (_ctx.isValidPermission('SEGURIDAD.ELIMINAR_USUARIO'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: _normalizeClass(['btn', user.active ? 'btn-outline-danger' : 'btn-outline-info']),
                                        onClick: $event => (_ctx.changeUserStatus(user.id,user.active))
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass([user.active ? 'fas fa-trash' : 'fas fa-check'])
                                        }, null, 2)
                                      ], 10, _hoisted_45))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_46, _hoisted_48))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("select", {
                    class: "custom-select mr-sm-2",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.perPage) = $event)),
                    onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.rowsPerPage && _ctx.rowsPerPage(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionPerPage, (option) => {
                      return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(option), 9, _hoisted_54))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.perPage]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_pagination, {
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.page) = $event)),
                  records: _ctx.records,
                  "per-page": _ctx.perPage,
                  options: _ctx.optionsPaginate,
                  onPaginate: _ctx.getResults
                }, null, 8, ["modelValue", "records", "per-page", "options", "onPaginate"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}